import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { ShowleftDirective } from '../../../directives/animations/showleft.directive';
import { ShowrightDirective } from '../../../directives/animations/showright.directive';

@Component({
  selector: 'section[app-home-fit-philosophy]',
  imports: [NgOptimizedImage, MatButtonModule, RouterModule, ShowleftDirective, ShowrightDirective],
  templateUrl: './home-fit-philosophy.html',
  styleUrl: './home-fit-philosophy.scss',
})
export class HomeFitPhilosophy {
  get appname(): string {
    return environment.appname;
  }
}
